/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 *
 * The selector is the only local change: the cart was moved off the shared
 * `<theme-drawer>` shell onto the drawer ported from the Inmyo theme, so it
 * is a `<cart-drawer-component>` now. Both are matched, so this keeps working
 * whichever drawer is in the page — including a Horizon update that restores
 * the original one.
 */

const CART_DRAWER_SELECTOR = 'cart-drawer-component#cart-drawer, theme-drawer#cart-drawer';

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector(CART_DRAWER_SELECTOR) ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector(CART_DRAWER_SELECTOR);

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
